module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 149.6a666b20.png";